import * as yup from 'yup';

// let yesterday = new Date(new Date().valueOf() - 1000 * 60 * 60 * 24);

export const validationSchema = yup.object().shape({
  site: yup.string().required('Site is a required field'),
  dayOfWeek: yup.string().required('SKU assigned is a required field'),
  deliveryAt: yup.date().required('Please enter the Delivery Date'),
  details: yup
    .array()
    .of(
      yup.object().shape({
        casesCount: yup
          .number()
          .min(0, 'Case Amount must be greater than or equal to 0')
          .nullable()
          .required('Case Amount is a required field'),
        sku: yup.string().required('SKU assigned is a required field'),
      }),
    )
    .required(),
});
